import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';

import { EstadoDoProcesso } from '@app/models/estado-do-processo.model';
import { EstadoDoProcessoService } from '@app/services/estado-do-processo.service';

@Component({
  selector: 'app-estado-do-processo-form',
  templateUrl: './estado-do-processo-form.component.html'
})
export class EstadoDoProcessoFormComponent implements OnInit {

  aguardandoSolicitacao : boolean = false;
  titulo: string;
  lstErros: string[];
  estadoDoProcesso: EstadoDoProcesso = new EstadoDoProcesso();

  constructor(
    private route: ActivatedRoute,
    private router: Router,
    private estadoDoProcessoService: EstadoDoProcessoService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      const id = params['id'];
      this.titulo = id ? 'Editar Estado do Processo' : 'Novo Estado do Processo';

      if (!id) {
        return;
      }

      this.estadoDoProcessoService.obterPorId(id).toPromise().then(
        data => this.estadoDoProcesso = data,
        () => this.router.navigate(['./configuracoes/estado-do-processo']));
    });
  }

  onSubmit() {
    this.aguardandoSolicitacao = true;
    this.estadoDoProcessoService.gravar(this.estadoDoProcesso).toPromise().then(
      () => this.router.navigate(['./configuracoes/estado-do-processo']),
      (data: any) => {
        if (data.error) {
          this.lstErros = data.error.errors;
        }
        this.aguardandoSolicitacao = false;
      });
  }
}
